'use strict';

 angular.module('config', [])

.constant('ENV', 
    {
        name:'qa',
        gigyaApiKey:'3_MBsZ_cWOq4t3GGfYTGBlcTC7UnYkr6x-UuyMwD9y91at59qZnzt7THnVF_4Urfc2',
        apiEndpoint:'https://qaproapi.zoetispetcare.com',
        tokenApiEndpoint: 'https://qaproproxyapi.zoetispetcare.com',
        sfmcStoriesSearchURL: 'https://sfmc-search.search.windows.net',
        sfmcStoriesSearchApiKey: 'AAE2038457A848DC4A4220AB8F2A1DB2',
        sfmcAssetsBaseUrl: 'https://sfmc.zpcdev.com',
        sfmcAssetsApiKey: 'eFN59DJev0u776/nhy4wZQ==',
        contentStackProxyUrl: 'https://api.zpcstage.com',
        adminURL:'https://qapro.zoetispetcare.com',
        proURL:'https://clinics.zpcdev.com',
        orderCardActivity:'410056608',
        pointConversionFactor:'10',
    }
);